import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpOrderCurveRequiredValidator
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * In cohesion with {@link pkpOrderCurve} searches for one curve point in the order curve that has a valid number
     * as a price and quantity.
     *
     * @attr {PkpUseOriginals} pkpUseOriginals
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive(
            'pkpOrderCurveRequiredValidator',
            pkpOrderCurveRequiredValidator
        );

    function pkpOrderCurveRequiredValidator(
        auctionsOverviewService,
        fieldKeyService
    ) {
        return {
            restrict: 'A',
            scope: false,
            require: ['ngModel', '^^pkpOrderCurve'],
            link: linkFn
        };

        function linkFn(scope, elem, attr, requiredControllers) {
            if (!scope.$first) {
                return;
            }

            var fieldKey = fieldKeyService.initialize(attr.pkpUseOriginals);

            var ngModelCtrl = requiredControllers[0];
            var pkpOrderCurveCtrl = requiredControllers[1];

            scope.$watch(
                function () {
                    if (pkpOrderCurveCtrl.orderCurve) {
                        return pkpOrderCurveCtrl.orderCurve;
                    }
                },
                function (newOrderCurve, oldOrderCurve) {
                    if (
                        !newOrderCurve ||
                        angular.equals(newOrderCurve, oldOrderCurve)
                    ) {
                        return;
                    }

                    validate(newOrderCurve);
                },
                true
            );

            /**
             * Check if there is a valid bidding curve in {@link scope.bid.orderCurve}.
             * A valid bidding curve for now is nothing more than one with non-empty price and quantity values.
             *
             * @param {Object[]} orderCurve
             * @returns {boolean} true if there is a bidding curve with non-empty price and quantity values,
             *  false otherwise.
             */
            function validate(orderCurve) {
                if (!orderCurve) {
                    ngModelCtrl.$setValidity(
                        'pkpOrderCurveRequiredValidator',
                        false
                    );
                    return false;
                }

                for (var i = 0; i < orderCurve.length; i++) {
                    var curvePoint = orderCurve[i];

                    if (
                        !curvePoint.quantity ||
                        !curvePoint.quantity[fieldKey.valueKey]
                    ) {
                        ngModelCtrl.$setValidity(
                            'pkpOrderCurveRequiredValidator',
                            false
                        );
                        continue;
                    }

                    var isValidCurvePoint;
                    try {
                        isValidCurvePoint =
                            auctionsOverviewService.isValidCurvePoint(
                                curvePoint.price[fieldKey.valueKey].value,
                                curvePoint.quantity[fieldKey.valueKey].value
                            );
                    } catch (e) {
                        continue;
                    }

                    if (isValidCurvePoint) {
                        ngModelCtrl.$setValidity(
                            'pkpOrderCurveRequiredValidator',
                            true
                        );
                        return true;
                    }
                }

                ngModelCtrl.$setValidity(
                    'pkpOrderCurveRequiredValidator',
                    false
                );
                return false;
            }
        }
    }
})();
